var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 15.86c2.84 0 5.14 2.3 5.14 5.14M3 11.57c5.2 0 9.43 4.22 9.43 9.43M3 7.29c7.57 0 13.71 6.14 13.71 13.71M3 3a18 18 0 0 1 18 18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogLine);
export default __webpack_public_path__ + "static/media/blog_line.4af705cb68b9b88307cfca5468bae125.svg";
export { ForwardRef as ReactComponent };